import {Component} from '@angular/core';
import {RedirectService} from '../../services/redirect.service';

@Component({
  standalone: false,
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss']
})
export class ThankYouComponent {

  constructor(public redirectService: RedirectService) {
  }
}
